/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersCreate } from "../funcs/userSessionIssuersCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateUserSessionIssuerRequest,
  CreateUserSessionIssuerSecurity,
} from "../models/operations/createusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateUserSessionIssuerMutationVariables = {
  request: CreateUserSessionIssuerRequest;
  security?: CreateUserSessionIssuerSecurity | undefined;
  options?: RequestOptions;
};

export type CreateUserSessionIssuerMutationData = UserSessionIssuer;

export type CreateUserSessionIssuerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createUserSessionIssuer userSessionIssuers
 *
 * @remarks
 * Create a new user_session_issuer.
 */
export function useCreateUserSessionIssuerMutation(
  options?: MutationHookOptions<
    CreateUserSessionIssuerMutationData,
    CreateUserSessionIssuerMutationError,
    CreateUserSessionIssuerMutationVariables
  >,
): UseMutationResult<
  CreateUserSessionIssuerMutationData,
  CreateUserSessionIssuerMutationError,
  CreateUserSessionIssuerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateUserSessionIssuerMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateUserSessionIssuer(): MutationKey {
  return ["@gram/client", "userSessionIssuers", "create"];
}

export function buildCreateUserSessionIssuerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateUserSessionIssuerMutationVariables,
  ) => Promise<CreateUserSessionIssuerMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateUserSessionIssuer(),
    mutationFn: function createUserSessionIssuerMutationFn({
      request,
      security,
      options,
    }): Promise<CreateUserSessionIssuerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(userSessionIssuersCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
